import Enum from 'enum';

const roleType = new Enum({
  Admin: 0,
  Supplier: 1,
  Manager: 2,
  Merchandiser: 3,
  WarehouseEmployee: 4,
  Buyer: 5,
  RolesManager: 6,
},
{
  name: 'RoleType',
  freez: true,
  ignoreCase: true,
});

export default roleType;
